import { Navigate, useLocation, useNavigate } from "react-router-dom";

import { useEffect, useState } from "react";

// context
import { useAuth } from "./AuthContext";

// idle-timer
import { useIdleTimer } from "react-idle-timer";

// token 
import { ensureAuth, clearAccessToken } from "./token";

const blockedListUrl = ['/medCard', '/makeAppointment/direction'];

export default function RequireVerified({ children }) {
  const { isVerified, setIsShowWarning, setMessageWarning } = useAuth();
  const { pathname } = useLocation();
  const navigate = useNavigate()

  const [authState, setAuthState] = useState({
    loading: true,
    success: false
  });

  // проверка на валидность токена
  useEffect(() => {
    let active = true;

    (async () => {
      const result = await ensureAuth();

      if (!active) return;

      setAuthState({
        loading: false,
        success: result.success
      });
    })();

    return () => {
      active = false;
    };
  }, [pathname]);

  useEffect(() => {
    setIsShowWarning(false);
    setMessageWarning({
      title: '',
      description: ''
    })
  }, [pathname])

  // Функция которая отрабатывает, если пользователь бездействует
  const handleOnIdle = () => {
    clearAccessToken();
    return navigate('/login');
  }

  useIdleTimer({
    timeout: 15 * 60 * 1000,
    onIdle: handleOnIdle,
    debounce: 1000,  // вызываем раз в 1 секунду
    events: ['mousemove', 'keydown', 'wheel', 'touchstart', 'click']
  })

  if (authState.loading) {
    return null;
  }

  if (!authState.success) {

    localStorage.removeItem('isFillProfile');
    localStorage.removeItem('isVerified');
    
    return <Navigate to='/login' replace/>
  }

  if (!isVerified) {
    const isBlocked = blockedListUrl.some((path) => pathname === path || pathname.startsWith(path));

    if (isBlocked) {
      return <Navigate to='/main?mode=confirm' replace/>
    }
  }
  return children;
}